export const WorkProgressStateData: any = [
  {
    code: 0,
    text: "開始前",
    color: "#026C40",
    description: "before_start"
  },
  {
    code: 1,
    text: "見積中",
    color: "#0351c0",
    decription: "estimating"
  },
  {
    code: 2,
    text: "検査中",
    color: "#FF002B",
    decription: "kensa_inspecting"
  },
  {
    code: 3,
    text: "検査済",
    color: "#026C40",
    decription: "finish"
  },
  {
    code: 4,
    text: "点検中",
    color: "#FF002B",
    decription: "tenken_inspecting"
  },
  {

    code: 5,
    text: "選択中",
    color: "#0351c0",
    decription: "selecting"
  },
  {
    code: 6,
    text: "待機中",
    color: "#000000",
    decription: "standby"
  },
  {
    code: 7,
    text: "整備中",
    color: "#0351c0",
    decription: "maintenance"
  },
  {
    code: 8,
    text: "整備保留",
    color: "#FF002B",
    decription: "maintenance_pending"
  },
  {
    code: 9,
    text: "部品待ち",
    color: "#FF002B",
    decription: "waiting_parts"
  },
  {
    code: 10,
    text: "完検待ち",
    color: "#FF002B",
    decription: "completion_check"
  },
  {
    code: 11,
    text: "割当中",
    color: "#0351c0",
    decription: "assigning"
  },
  {
    code: 12,
    text: "整備済",
    color: "#0351c0",
    decription: "rehabilitation"
  },
  {
    code: 13,
    text: "完検中",
    color: "#FF002B",
    decription: "under_inspection"
  },
  {
    code: 14,
    text: "車検済",
    color: "#026C40",
    decription: "completed"
  },
  {
    code: 15,
    text: "車検中止",
    color: "red",
    decription: "completed"
  },
  {
    code: 16,
    text: "見積保留",
    color: "#0351c0",
    decription: "on_hold"
  }
];
